/* Label & Leaf — wood→wood crossfade for the ll-artframe engine.
   Progressive enhancement over ll-art-frame.css: watches data-frame changes
   (attribute may sit on .ll-artframe or any ancestor — see the CSS contract),
   paints the outgoing texture on .ll-artframe__frame::after (--ll-frame-prev)
   and replays the .ll-xfade fade-out. Asset URLs come from this script tag's
   data-ll-frame-assets JSON. Pass absolute URLs in production (Liquid
   asset_url): a relative url() inside a custom property resolves against the
   stylesheet that substitutes it (ll-art-frame.css's directory), which
   absolute URLs sidestep across engines. */
(function () {
  'use strict';
  var tag = document.querySelector('script[data-ll-frame-assets]');
  if (!tag || !('MutationObserver' in window)) return;
  var assets;
  try { assets = JSON.parse(tag.getAttribute('data-ll-frame-assets')); } catch (e) { return; }

  function framesFor(target) {
    if (target.classList && target.classList.contains('ll-artframe')) {
      var direct = [];
      for (var i = 0; i < target.children.length; i++) {
        if (target.children[i].classList.contains('ll-artframe__frame')) direct.push(target.children[i]);
      }
      return direct;
    }
    return target.querySelectorAll ? target.querySelectorAll('.ll-artframe > .ll-artframe__frame') : [];
  }

  new MutationObserver(function (muts) {
    var seen = new Set();
    muts.forEach(function (m) {
      if (seen.has(m.target)) return; /* keep only the first record per target */
      seen.add(m.target);
      var oldV = m.oldValue;
      var newV = m.target.getAttribute && m.target.getAttribute('data-frame');
      if (!oldV || !newV || oldV === newV) return; /* net no-op across the batch */
      if (!assets[oldV] || !assets[newV]) return; /* only wood→wood */
      var frames = framesFor(m.target);
      for (var i = 0; i < frames.length; i++) {
        var f = frames[i];
        f.style.setProperty('--ll-frame-prev', 'url("' + assets[oldV] + '")');
        f.classList.remove('ll-xfade');
        void f.offsetWidth; /* restart the animation */
        f.classList.add('ll-xfade');
      }
    });
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-frame'],
    attributeOldValue: true,
  });

  /* DOM hygiene: once the fade-out finishes, drop the class and inline
     property so devtools don't show stale crossfade state. Purely cosmetic —
     the ghost is already at opacity 0 when the animation ends. */
  document.addEventListener('animationend', function (e) {
    if (e.animationName !== 'll-frame-xfade') return;
    e.target.classList.remove('ll-xfade');
    e.target.style.removeProperty('--ll-frame-prev');
  });
})();
